import { utilities } from "./utilities"
utilities.scrollDierectionChecker()
